import { render, staticRenderFns } from "./NodeFieldsets.vue?vue&type=template&id=4359601a"
import script from "./NodeFieldsets.vue?vue&type=script&lang=js"
export * from "./NodeFieldsets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports